export default "/048cb1f2b29308e18768c65cfd51e426596a830c/ed3e1222f5d7e466f1889a4510f1de5c.svg";